"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalError = void 0;
const UpsError_1 = require("./UpsError");
class InternalError extends UpsError_1.UpsError {
    constructor(message, details = {}) {
        super('InternalError', message, details);
    }
}
exports.InternalError = InternalError;
//# sourceMappingURL=InternalError.js.map